import type { GroupDetail } from '@/types'

export interface DisplayableGroup {
  /** The group ID, as used for workflow assignment. */
  id: string
  /** The display name, or the ID when the group has none. */
  label: string
}

/**
 * Builds the groups of the user dropdown from the group details, falling back to plain group IDs.
 * Entries are labelled by display name but keep their ID, which is what workflows reference.
 */
export const getDisplayableGroupItems = (
  details?: GroupDetail[],
  fallback?: string[],
): DisplayableGroup[] => {
  const entries = details ?? (fallback ?? []).map((id) => ({ id, displayName: '' }))
  const seen = new Set<string>()
  const items: DisplayableGroup[] = []
  for (const entry of entries) {
    const id = entry.id.trim()
    const key = id.toLowerCase()
    if (!id || seen.has(key)) continue
    seen.add(key)
    items.push({ id, label: entry.displayName?.trim() || id })
  }
  return items
}
